import { render, staticRenderFns } from "./DeviceTypeRestoreDialog.vue?vue&type=template&id=2a0e24a5&scoped=true"
import script from "./DeviceTypeRestoreDialog.vue?vue&type=script&lang=ts"
export * from "./DeviceTypeRestoreDialog.vue?vue&type=script&lang=ts"
import style0 from "./DeviceTypeRestoreDialog.vue?vue&type=style&index=0&id=2a0e24a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0e24a5",
  null
  
)

export default component.exports